import { promotions } from './promotions';
import { users } from './users';
import { chat } from './chat';

export const api = { promotions, users, chat };
